import {
	Button,
	Col,
	Divider,
	Form,
	Row,
	Select,
	notification,
	Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
const { Text, Title } = Typography;

const optionsContactGlobal = [
	{
		value: "New Job",
		label: "New Job",
	},
	{
		value: "Job Follow Up",
		label: "Job Follow Up",
	},
	{
		value: "Quality",
		label: "Quality",
	},
	{
		value: "Company Presentation",
		label: "Company Presentation",
	},
];

const optionsPropsectionType = [
	{
		value: "Contact",
		label: "Contact",
	},
	{
		value: "Meeting",
		label: "Meeting",
	},
	{
		value: "Negotiation",
		label: "Negotiation",
	},
	{
		value: "Credit App",
		label: "Credit App",
	},
];

const optionsType = [
	{
		value: "Call",
		label: "Call",
	},
	{
		value: "Meeting",
		label: "Meeting",
	},
	{
		value: "Email",
		label: "Email",
	},
];

/**
 ** Options header (columns)
 */
const columns = [
	{
		title: "Date",
		dataIndex: "date",
		key: "date",
		render: (value) => {
			return <Text strong>{value}</Text>;
		},
	},
	{
		title: "Customer",
		dataIndex: "customer",
		key: "customer",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Type",
		dataIndex: "type",
		key: "type",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Prospection Type",
		dataIndex: "prospectionType",
		key: "prospectionType",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Contact Global",
		dataIndex: "contactGlobal",
		key: "contactGlobal",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Created By",
		dataIndex: "user",
		key: "user",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
];

const CreateCustomerTask = ({ from, seller, setModal, onCreated }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(true);
	const [loadingButton, setLoadingButton] = useState(false);
	const [loadingTable, setLoadingTable] = useState(false);
	const [historyTasks, setHistoryTasks] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();
	const [customerList, setCustomerList] = useState([]);
	const [customerLoading, setCustomerLoading] = useState(true);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getCustomers();
	}, []);

	const getCustomers = async () => {
		setLoading(true);
		let url = "";
		if (from === "prospect") {
			url = api + `/customer/list/prospect/byseller/${seller}`;
		} else if (from === "followup") {
			url = api + `/customer/list/regular/byseller/${seller}`;
		}
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [];
			if (data.success) {
				data.payload.map((item, index) => {
					list.push({
						key: index,
						value: item._id,
						label:
							item.registrationComplete === false
								? item.name
								: `${item.customerNumber} ${item.name}`,
					});
				});
				setCustomerList(list);
				setCustomerLoading(false);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const onChangeCustomer = async (customer) => {
		setLoadingTable(true);

		try {
			const url = api + `/customertask/get/list/bycustomer/${customer}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						index: index,
						customer: `${item.customer.customerNumber} ${item.customer.name}`,
						type: item.type,
						prospectionType: item.prospectionType || "-",
						contactGlobal: item.contactGlobal,
						date: new Intl.DateTimeFormat("en-US", {
							month: "numeric",
							year: "numeric",
							day: "numeric",
							hour: "2-digit",
							minute: "2-digit",
							second: "2-digit",
						}).format(new Date(item.createdAt)),
						user: item.createdBy.name,
					});
				});
				setHistoryTasks(list);
				setLoadingTable(false);
			} else {
				setLoadingTable(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			setLoadingTable(false);
			openNotification("error", "Error", "Error while trying to create task");
			console.error(err.message);
			return null;
		}
	};

	const createTask = async (values) => {
		setLoadingButton(true);
		const task = {
			...values,
			from: from === "prospect" ? "Prospect" : "Follow Up",
		};

		try {
			const url = api + `/customertask/create`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.post(url, task);
			if (data.success) {
				openNotification("success", "Success", data.message);

				setTimeout(() => {
					setLoadingButton(false);
					if (from === "prospect") {
						setModal(false);
					} else {
						onCreated();
					}
				}, 2000);
			} else {
				setLoadingButton(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			setLoadingButton(false);
			openNotification("error", "Error", "Error while trying to create task");
			console.error(err.message);
			return null;
		}
	};

	const onFinish = (values) => {
		createTask(values);
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				onFinish={onFinish}
				style={{ marginTop: "20px" }}
			>
				<Row gutter={16}>
					<Col span={24} sm={12}>
						<Form.Item
							label="Customer"
							name="customer"
							rules={[
								{
									required: true,
									message: "Customer is required",
								},
							]}
						>
							<Select
								style={{
									width: "100%",
								}}
								size="large"
								placeholder="Please select customer"
								options={customerList}
								optionFilterProp="children"
								filterOption={filterOption}
								showSearch
								loading={customerLoading}
								onChange={onChangeCustomer}
							/>
						</Form.Item>
					</Col>
					<Col span={24} sm={12}>
						<Form.Item
							label="Type"
							name="type"
							rules={[
								{
									required: true,
									message: "Type is required",
								},
							]}
						>
							<Select
								style={{
									width: "100%",
								}}
								size="large"
								placeholder="Please select type"
								options={optionsType}
								optionFilterProp="children"
								filterOption={filterOption}
								showSearch
							/>
						</Form.Item>
					</Col>
					{from === "prospect" && (
						<Col span={24} sm={12}>
							<Form.Item
								label="Prospection Type"
								name="prospectionType"
								rules={[
									{
										required: true,
										message: "Type is required",
									},
								]}
							>
								<Select
									style={{
										width: "100%",
									}}
									size="large"
									placeholder="Please select prospection type"
									options={optionsPropsectionType}
									optionFilterProp="children"
									filterOption={filterOption}
									showSearch
								/>
							</Form.Item>
						</Col>
					)}
					<Col span={24} sm={12}>
						<Form.Item
							label="Contact Global"
							name="contactGlobal"
							rules={[
								{
									required: true,
									message: "Type is required",
								},
							]}
						>
							<Select
								style={{
									width: "100%",
								}}
								size="large"
								placeholder="Please select type"
								options={optionsContactGlobal}
								optionFilterProp="children"
								filterOption={filterOption}
								showSearch
							/>
						</Form.Item>
					</Col>
				</Row>
				<Divider />
				<Title level={3}>History</Title>
				<CustomTable
					loading={loadingTable}
					columns={columns}
					data={historyTasks}
					isScroll={false}
				/>

				<Row gutter={16}>
					<Col span={24} sm={12} md={4}>
						<Button
							type="primary"
							htmlType="submit"
							loading={loadingButton}
							size="large"
							style={{
								width: "100%",
							}}
						>
							Save
						</Button>
					</Col>
				</Row>
			</Form>
		);
	};

	return (
		<div>
			{contextHolder}
			{loading ? <CustomSpinner /> : <CustomForm />}
		</div>
	);
};

export default CreateCustomerTask;
